<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="12" md="6">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-form @submit.prevent="register" autocomplete="off">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Jednoduchá registrácia</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              Stačí email a heslo. Po registrácii ti príde overovací kód na email a
              hneď po jeho zadaní získaš úroveň 2 (môžeš hlasovať a písať komentáre).
            </v-card-text>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" name="Email" vid="email1"
                    :rules="{ required: true, email: true }">
                    <v-text-field v-model="form.email" :error-messages="errors" label="Email"
                      prepend-icon="mdi-email" hint="Napríklad boris@example.sk" type="text"
                      @click.right.prevent @copy.prevent @paste.prevent />
                  </validation-provider>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" name="Heslo" rules="required|min:10" vid="password1">
                    <v-text-field v-model="form.password" :error-messages="errors" label="Heslo"
                      prepend-icon="mdi-lock" hint="Heslo si zvol bezpečné. Minimálna dĺžka je 10 znakov."
                      :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" @click.right.prevent
                      @copy.prevent @paste.prevent />
                  </validation-provider>
                </v-col>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" name="Heslo znovu" rules="confirmed:password1">
                    <v-text-field v-model="form.password2" :error-messages="errors" label="Heslo znovu"
                      prepend-icon="mdi-lock" :type="show2 ? 'text' : 'password'"
                      hint="Zadaj rovnaké heslo ako predtým."
                      @click:append="show2 = !show2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click.right.prevent @copy.prevent @paste.prevent />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn :disabled="invalid || loading" :loading="loading" color="primary" type="submit">
                Zaregistrovať sa
              </v-btn>
            </v-card-actions>
            <v-card-text v-if="error" class="red--text">
              {{ error }}
            </v-card-text>
          </v-card>
        </v-form>
      </validation-observer>
    </v-col>
  </v-row>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate';
import { required, confirmed, email, min } from 'vee-validate/dist/rules';

const apiService = new APIService();

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} nemôže byť prázdne',
});
extend('email', {
  ...email,
  message: 'Zadaj platný email',
});
extend('min', {
  ...min,
  message: '{_field_} musí mať aspoň {length} znakov',
});
extend('confirmed', {
  ...confirmed,
  message: 'Heslá sa nezhodujú',
});

export default {
  name: 'RegisterSimple',
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      loading: false,
      error: null,
      show1: false,
      show2: false,
      // The backend's RegisterSerializer still requires `username` (it's a
      // Django AbstractUser field). Derive it from the email local-part as a
      // sensible default; the user can change it later in /profile.
      form: {
        email: '',
        password: '',
        password2: '',
      },
    };
  },
  methods: {
    register() {
      this.error = null;
      this.$refs.observer.validate().then((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        const localPart = this.form.email.split('@')[0];
        const basePayload = {
          email: this.form.email,
          password: this.form.password,
          password2: this.form.password2,
        };
        // Try to register with a derived username; if the username is already
        // taken (e.g. another user with the same email local-part), retry
        // with a numeric suffix up to 5 times.
        this.tryRegister(localPart, 0, basePayload)
          .then(() => {
            // Auto-login so the user lands on /register_verify already
            // authenticated. /register_verify has a `requireAuthenticated`
            // guard, so without this the user would be bounced to /login.
            return this.$store.dispatch('auth/login', {
              username: this.form.email,
              password: this.form.password,
            });
          })
          .then(() => {
            this.$router.push({ path: '/register_verify' });
          })
          .catch((err) => {
            this.error = (err && err.response && err.response.data)
              ? JSON.stringify(err.response.data)
              : 'Registrácia zlyhala. Skús to znova.';
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    tryRegister(localPart, attempt, basePayload) {
      const username = attempt === 0 ? localPart : `${localPart}_${attempt}`;
      return apiService.register({ ...basePayload, username }).catch((err) => {
        const data = err && err.response && err.response.data;
        // Only retry on a "username already exists" style error, and only
        // up to 5 attempts to avoid an infinite loop on a hostile input.
        if (attempt < 5 && data && data.username) {
          return this.tryRegister(localPart, attempt + 1, basePayload);
        }
        throw err;
      });
    },
  },
};
</script>
